export enum LoanType {
    Construction = 1,
    Rental = 2,
    BuildRent = 3,
    Model = 4,
    Land = 5,
    FixFlip = 6,
    MasterNote = 7,
    SubNoteConstruction = 8,
    SubNoteFixFlip = 9,
}

const loanTypeDescription: string[] = [];
loanTypeDescription[LoanType.Construction] = 'Construction';
loanTypeDescription[LoanType.Rental] = 'Rental';
loanTypeDescription[LoanType.BuildRent] = 'Build Rent';
loanTypeDescription[LoanType.Model] = 'Model';
loanTypeDescription[LoanType.Land] = 'Land';
loanTypeDescription[LoanType.FixFlip] = 'Fix Flip';
loanTypeDescription[LoanType.MasterNote] = 'Master Note';
loanTypeDescription[LoanType.SubNoteConstruction] = 'Construction Sub Note';
loanTypeDescription[LoanType.SubNoteFixFlip] = 'Fix Flip Sub Note';

export { loanTypeDescription };
